export default "__VITE_ASSET__D47g_2Jy__"